import React, { useEffect, useState } from "react";
import { MapPin, PackageCheck } from "lucide-react";
import api from "@/lib/api";

const KEY = "hb_postcode";
export const fmtDay = (iso, withMonth = true) => {
  const d = new Date(iso + "T00:00:00");
  return `${d.toLocaleDateString("en-AU", { weekday: "short" })} ${d.getDate()}${withMonth ? ` ${d.toLocaleDateString("en-AU", { month: "short" })}` : ""}`;
};
export const windowLabel = (est) => est ? `${fmtDay(est.earliest, est.earliest.slice(0, 7) !== est.latest.slice(0, 7))} – ${fmtDay(est.latest)}` : "";

export default function CheckoutPostcode({ cart, postcode, setPostcode, onEstimate }) {
  const [est, setEst] = useState(null);
  const ids = cart.flatMap((i) => (i.type === "bundle" ? (i.components || []).map((c) => c.product_id) : [i.id])).filter(Boolean).join(",");

  useEffect(() => {
    if (!/^\d{4}$/.test(postcode)) { setEst(null); onEstimate(null); return; }
    let live = true;
    api.post("/delivery-estimate", { postcode, product_ids: ids.split(",") })
      .then(({ data }) => { if (live) { setEst(data); onEstimate(data); localStorage.setItem(KEY, postcode); } })
      .catch(() => { if (live) { setEst(null); onEstimate(null); } });
    return () => { live = false; };
  }, [postcode, ids]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mt-4 rounded-2xl bg-[#FFF9EE] p-4" data-testid="checkout-postcode-box">
      <div className="flex items-center gap-2">
        <MapPin className="w-5 h-5 text-[#4CC9F0] shrink-0" />
        <label htmlFor="checkout-postcode" className="text-sm font-semibold text-[#19324A] whitespace-nowrap">Delivery postcode</label>
        <input id="checkout-postcode" inputMode="numeric" maxLength={4} value={postcode} onChange={(e) => setPostcode(e.target.value.replace(/\D/g, ""))} placeholder="e.g. 4000"
          className="w-24 rounded-xl border-2 border-[#19324A]/10 bg-white px-3 py-1.5 text-sm outline-none focus:border-[#4CC9F0]" data-testid="checkout-postcode" />
      </div>
      <p className="text-xs text-[#19324A]/45 mt-1.5 ml-7">Optional — we'll show an arrival estimate. Your full address is collected at the payment step.</p>
      {est && (
        <p className="mt-2.5 inline-flex items-start gap-2 text-sm text-[#19324A]" data-testid="checkout-arrival">
          <PackageCheck className="w-4 h-4 text-[#7ED957] shrink-0 mt-0.5" />
          <span>Estimated arrival <strong data-testid="checkout-arrival-window">{windowLabel(est)}</strong> to {est.postcode}
            {est.cutoff && <span className={`block text-xs font-semibold ${est.cutoff.in_time ? "text-[#166534]" : "text-[#B91C1C]"}`} data-testid="checkout-arrival-cutoff">{est.cutoff.in_time ? `✓ In time for ${est.cutoff.label}` : `May arrive after Christmas`}</span>}
          </span>
        </p>
      )}
    </div>
  );
}
